<template>
  <GChart
    :settings="{packages: ['corechart']}"
    type="ColumnChart"
    :data="multiyears ? columnChartdataWithYears : columnChartdata"
    :options="dynamicOptions"
	:events="chartEvents"
	ref = "gChart"
  />
</template>

<script>
import { GChart } from "vue-google-charts";

export default {
  components: { GChart },
  props: ["chartdata","chartcolumns","years","categ","subcateg","userColumnsData"],
  mounted() {
    $("#legendtitle").val(null); //no default value for legend title
  },
  data() {
    return {
      chartsLib: null,
      colsel: null,
      options: {
        height: 500,
        width: "100%",
        animation: {
          duration: 400,
          startup: true,
        },
        colors: [
          "#cc9900",
          "#66cccc",
          "#cc66cc",
          "#003399",
          "#d16128",
          "#33cc33",
          "#6666cc",
          "#bc2626",
          "#339933",
          "#72530e",
        ],
		vAxis: { minValue: 0 },
        legend: { position: "top", maxLines: 5 }
      },
	  userColors: [
	    "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7",
	    "#DDA0DD", "#98D8C8", "#F7DC6F", "#BB8FCE", "#85C1E9"
	  ],
      chartEvents: {
        select: () => {
          const colchart = this.$refs.gChart.chartObject;
          const selection = colchart.getSelection();
          //console.log(this.chartcolumns);
          //console.log(selection[0].column);
		  if (selection.length > 0) {
			const selectedColumn = selection[0].column - 1; // -1 because first column is labels
			const originalDataCount = this.chartdata.length;
			
			// Only trigger changeCol for original data, not user data
			if (selectedColumn >= 0 && selectedColumn < originalDataCount) {
				this.colsel = this.chartcolumns[selectedColumn];
				this.changeCol();
			}
			// If user data column is clicked, do nothing
		  }
		},
      },
    };
  },
  methods: {
    onChartReady(chart, google) {
      this.chartsLib = google;
    },
    runSerial(tasks) {
      var result = Promise.resolve();
      tasks.forEach((task) => {
        result = result.then(() => task());
      });
      return result;
    },
    changeCol() {
      //console.log(this.categ.id, this.subcateg.id, this.lastYear, this.colsel);
      let tasks = [
        () => {
          $("#categ1")
            .val(this.categ.id)
            .change();
        },
        () => {
          $("#categ2")
            .val(this.subcateg.id)
            .change();
        },
        () => {
          $("#year")
            .val(this.lastYear)
            .change();
        },
        () => {
          $("#categ3")
            .val(this.colsel)
            .change();
        },
        () => {
          this.$root.$emit("retract_panel");
        },
      ];

      this.runSerial(tasks);
    },
  },
  computed: {
    multiyears() {
      return this.years != null && this.years.length > 1;
    },
    columnChartdataWithYears() {
      //let labels = ["Labels"].concat(this.chartdata.map(x => x[0]+'<img src="../../assets/images/6-analysis/add.png"></img>'))
      let labels = ["Labels"].concat(this.chartdata.map((x) => x[0]));
      let rows = [];
      this.years.forEach((y, i) => {
        rows.push([y].concat(this.chartdata.map((x) => x[i + 1])));
      });
	  // Add user data if it exists
	  if (this.userColumnsData && this.userColumnsData.length > 0) {
		  // Add user column titles to labels
		  this.userColumnsData.forEach((userCol) => {
		  if (userCol.title.trim() !== '') {  // Only add columns with titles
			  labels.push(userCol.title);
		  }
		  });
		  
		  // Add user data to each year row
		  rows.forEach((row, yearIndex) => {
		  this.userColumnsData.forEach((userCol) => {
			  if (userCol.title.trim() !== '') {  // Only add columns with titles
				const value = userCol.data[yearIndex];
				row.push(parseFloat(value) || 0);
			  }
		  });
		  });
	  }

      return [labels].concat(rows);
    },
    columnChartdata() {
      let labels = ["Labels"];
      let values = [""];
      this.chartdata.forEach((d) => {
        //labels.push(d[0]+'<img src="../../assets/images/6-analysis/add.png"></img>')
        labels.push(d[0]);
        values.push(d[1] ? d[1] : 0);
      });
      // Add user data for single year
      if (this.userColumnsData && this.userColumnsData.length > 0) {
        this.userColumnsData.forEach((userCol) => {
          if (userCol.title.trim() !== '') {  // Only add columns with titles
            labels.push(userCol.title);
            const lastValue = userCol.data[userCol.data.length - 1];
            values.push(parseFloat(lastValue) || 0);
          }
        });
      }

      return [labels, values];
    },
    lastYear() {
      return this.years[this.years.length - 1];
    },
    dynamicOptions() {
      return Object.assign({}, this.options, {
        colors: this.chartColors
      });
    },
    chartColors() {
      // Combine original colors with user colors
      return this.options.colors.concat(this.userColors);
    },
  },
};
</script>

<style>
</style>
